import { useLazyQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import { GET_EDUCATION_RESOURCES } from '../../../query/contentQuery'

const RESOURCE_TYPE = ['Key Resources', 'Video Library', 'More Resources']
const RESOURCE_KEY = ['resources.key', 'resources.video', 'resources.more']

const MobileResources = ({ productLine }) => {
  const [resources, setResources] = useState([])

  const [loadResources] = useLazyQuery(GET_EDUCATION_RESOURCES, {
    fetchPolicy: 'cache-and-network',
    onError (err) {
      console.error(err)
    },
    onCompleted (payload) {
      const _resources = payload.educationResources
      setResources(_resources)
    }
  })

  useEffect(() => {
    loadResources({
      variables: {
        productLine
      }
    })
  }, [])

  const keyResources = resources.filter(res => res.category === RESOURCE_TYPE[0])
    .sort((res1, res2) => res1.educationResourcesGroups[0]?.position - res2.educationResourcesGroups[0]?.position)
  const videoLibrary = resources.filter(res => res.category === RESOURCE_TYPE[1])
    .sort((res1, res2) => res1.educationResourcesGroups[0]?.position - res2.educationResourcesGroups[0]?.position)
  const moreResources = resources.filter(res => res.category === RESOURCE_TYPE[2])
    .sort((res1, res2) => res1.educationResourcesGroups[0]?.position - res2.educationResourcesGroups[0]?.position)

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5rem', textAlign: 'left', width: '100%', padding: '3rem 2rem' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
        <div style={{ fontSize: '1.5rem', color: 'white' }}>
          <Trans i18nKey={RESOURCE_KEY[0]}>{RESOURCE_TYPE[0]}</Trans>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {
            keyResources.map((edu) =>
              <div key={edu.name}>
                <a href={edu.documentLinks[0]?.url ?? edu.files[0]?.url} target='_blank' rel='noreferrer'>{edu?.name}</a>
              </div>)
          }
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
        <div style={{ fontSize: '1.5rem', color: 'white' }}>
          <Trans i18nKey={RESOURCE_KEY[1]}>{RESOURCE_TYPE[1]}</Trans>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {
            videoLibrary.map((edu) =>
              <div key={edu.name}>
                <a href={edu.documentLinks[0]?.url ?? edu.files[0]?.url} target='_blank' rel='noreferrer'>{edu?.name}</a>
              </div>)
          }
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
        <div style={{ fontSize: '1.5rem', color: 'white' }}>
          <Trans i18nKey={RESOURCE_KEY[2]}>{RESOURCE_TYPE[2]}</Trans>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {
            moreResources.map((edu) =>
              <div key={edu.name}>
                <a href={edu.documentLinks[0]?.url ?? edu.files[0]?.url} target='_blank' rel='noreferrer'>{edu?.name}</a>
              </div>)
          }
        </div>
      </div>
    </div>
  )
}

export default MobileResources
